exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active{background-color:#000;color:#fff}.special-filter li a{padding:10px 5px!important}.filter-icon svg{height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5d262ae","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/bhf-filter/bhf-special-filter-switcher.vue
// module id = N10o
// module chunks = 2